module.exports = __webpack_public_path__ + "img/slide-6-1.b73e2fdd.jpg";